import { motion, useReducedMotion } from 'framer-motion';

import pt from '../../locales/pt';
import { LANDING_EASE } from './ScrollReveal';

/**
 * Feature visual — emergency fund card on Landing features row.
 */
export function EmergencyFundMiniApp() {
  const data = pt.landing.features.miniFund;
  const reduceMotion = useReducedMotion();

  return (
    <div className="w-full max-w-[340px] rounded-ds-xl border border-border bg-card p-space-6">
      <p className="type-section text-sage-700 dark:text-sage-300">{data.title}</p>
      <p className="type-display-kpi mt-space-3 text-foreground">{data.have}</p>
      <p className="type-body-sm mt-space-1 text-muted-foreground">{data.ofMonths}</p>
      <div className="mt-space-4 h-2.5 overflow-hidden rounded-ds-full bg-stone-100 dark:bg-stone-700">
        <motion.div
          className="h-full rounded-ds-full bg-sage-500"
          initial={reduceMotion ? false : { width: 0 }}
          whileInView={{ width: `${data.trackPct}%` }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.7, delay: 0.2, ease: LANDING_EASE }}
        />
      </div>
      <p className="type-body-sm mt-space-3 text-muted-foreground">{data.progress}</p>
    </div>
  );
}
